import React from 'react';


export default class footer extends React.Component {

    render() {
        return <section>

            <div className="footer">
                <div className="container-full">
                    <div className="gr-4">
                        <ul>
                            <li>
                                <a href="/#/"><b>JOEL KERNASENKO</b></a>
                            </li>
                        </ul>

                    </div>
                    <div className="gr-8">
                        <ul className="pull-right menu">
                            <li>
                                <a href="/#/">Impressum</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="clearfix"></div>
            </div>
        </section>
    }

}


// WEBPACK FOOTER //
// ./src/scripts/components/footer.jsx